import { FlightPlanInfo } from '@components/map/popup';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectSituationFlightPlanById } from '@redux/situation/situation.selectors';
import { useState } from 'react';

import { FlightPlanInfoData, PopupPositionData } from '@/types/popup.types';
import { AbstractFlightPlan } from '@/types/utm/flightPlan.types';

export default function FlightPlanInfoWrapper(props: Readonly<FlightPlanInfoData & PopupPositionData>) {
  const { featureValue, onClose } = props;
  const ongoingFlightPlan = useSelectorWithReplayMode(selectSituationFlightPlanById, featureValue.id);
  const [previousSituationFlightPlan, setPreviousSituationFlightPlan] = useState<AbstractFlightPlan | null>(
    ongoingFlightPlan,
  );

  if (ongoingFlightPlan === null && previousSituationFlightPlan !== null) {
    setPreviousSituationFlightPlan(null);
    onClose();
    return null;
  } else if (previousSituationFlightPlan !== ongoingFlightPlan) {
    setPreviousSituationFlightPlan(ongoingFlightPlan);
  }

  const flightPlan = ongoingFlightPlan ?? featureValue;

  return <FlightPlanInfo {...props} featureValue={flightPlan} />;
}
